var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_box"},[_c('a-icon',{staticStyle:{"font-size":"36px"},attrs:{"type":"solution"}}),_c('div',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }